// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.skeleton-blog-block {
  margin-bottom: 15px;
  --padding-start: 16px;
  --padding-end: 16px;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  --min-height: 0;
  display: block;
  width: 100%;
}
.skeleton-blog-block__inner {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
}
.skeleton-blog-block__thumb {
  width: 100%;
  aspect-ratio: 16/9;
  max-height: 160px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}
.skeleton-blog-block__thumb ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
}
.skeleton-blog-block__label {
  margin: 0;
  width: 100%;
}
.skeleton-blog-block__line {
  margin: 0 0 8px;
  width: 100%;
}
.skeleton-blog-block__line:last-child {
  margin-bottom: 0;
}
.skeleton-blog-block__line ion-skeleton-text {
  margin: 0;
  width: 100%;
}
.skeleton-blog-block__line--title ion-skeleton-text {
  height: 18px;
}
.skeleton-blog-block__line--meta ion-skeleton-text {
  height: 14px;
}
.skeleton-blog-block__line--body ion-skeleton-text {
  height: 14px;
  max-width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/blog/skeleton-blog-block/skeleton-blog-block.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,eAAA;EAEA,cAAA;EACA,WAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AADN;AAKE;EACE,SAAA;EACA,WAAA;AAHJ;AAME;EACE,eAAA;EACA,WAAA;AAJJ;AAMI;EACE,gBAAA;AAJN;AAOI;EACE,SAAA;EACA,WAAA;AALN;AAQI;EACE,YAAA;AANN;AASI;EACE,YAAA;AAPN;AAUI;EACE,YAAA;EACA,cAAA;AARN","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.skeleton-blog-block {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n  --min-height: 0;\n\n  display: block;\n  width: 100%;\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n\n  &__thumb {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    max-height: 160px;\n    border-radius: 8px;\n    overflow: hidden;\n    margin-bottom: 12px;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 8px;\n    }\n  }\n\n  &__label {\n    margin: 0;\n    width: 100%;\n  }\n\n  &__line {\n    margin: 0 0 8px;\n    width: 100%;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    ion-skeleton-text {\n      margin: 0;\n      width: 100%;\n    }\n\n    &--title ion-skeleton-text {\n      height: 18px;\n    }\n\n    &--meta ion-skeleton-text {\n      height: 14px;\n    }\n\n    &--body ion-skeleton-text {\n      height: 14px;\n      max-width: 50%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
